<!-- Header Section -------------------------------------------------------------------------------------------------------------------------------->
<div class="header">

  <div class="left-buttons">
    <button class="style-button" (click)="createFolder()">
      <mat-icon>create_new_folder</mat-icon> {{'modal.folder.new' | transloco}}
    </button>
    <button class="style-button" (click)="triggerFolderUpload()">
      <mat-icon>file_upload</mat-icon> {{'modal.folder.upload' | transloco}}
    </button>
    <button class="style-button" (click)="triggerFileUpload()">
      <mat-icon>file_upload</mat-icon> {{'modal.file.upload' | transloco}}
    </button>
    <button class="style-button" (click)="openExternalUploadDialog()">
      <mat-icon>cloud_upload</mat-icon> {{'modal.file.uploadExt' | transloco}}
    </button>
  </div>

  <div class="right-buttons">
    <button class="style-button" (click)="refresh()">
      <mat-icon>refresh</mat-icon> {{'modal.file.refresh' | transloco}}
    </button>
    <button class="style-button" (click)="close()">
      <mat-icon>close</mat-icon> {{'modal.file.close' | transloco}}
    </button>
  </div>

  <input type="file" id="fileUpload" (change)="onFileSelected($event)" [accept]="getAcceptedFileTypes()" hidden>
  <input type="file" id="folderUpload" (change)="onFolderSelected($event)" webkitdirectory directory multiple hidden>

</div>

<!-- Drag and Drop Overlay ----------------------------------------------------------------------------------------------------------------------------------------->
<div *ngIf="isDragging && !isMovingFile" class="drag-overlay">
  Trascina i file qui per caricarli
</div>

<!--  Prima sezione del modal di caricametno file, sezione con menu cartelle ---------------------------------------------------------------------------------------->
<div class="content">
  <div class="navigation">
    <!--Cartelle-->
    <div class="folder-section" [class.full]="isRootSelected()">
      <kendo-treeview [nodes]="folders" class="folders-tree" textField="folderName" childrenField="children" [filterable]="true"
        kendoTreeViewExpandable kendoTreeViewHierarchyBinding kendoTreeViewSelectable [isExpanded]="isExpanded"
        (selectionChange)="onSelectionChange($event)" 
        [(selectedKeys)]="selectedKeys"
        (collapse)="handleCollapse($event)"
        (expand)="handleExpand($event)">
        <ng-template kendoTreeViewNodeTemplate let-dataItem>
          <div>
            <mat-icon [svgIcon]="'heroicons_solid:folder'"></mat-icon>
            {{ dataItem.folderName }}
          </div>
        </ng-template>
      </kendo-treeview>
    </div>
    
    <div class="footer-folder">

      <!-- Footer bottoni -->
      <div class="actions">
        <button class="style-button" (click)="renameFolder(selectedFolder)"
          [disabled]="!isFileOwner(selectedFolder) || isFileSystem(selectedFolder)">
          <mat-icon>edit</mat-icon>{{'modal.file.rename' | transloco}}
        </button>

        <button class="style-button" (click)="deleteFolder(selectedFolder)"
          [disabled]="!isFileOwner(selectedFolder) || isFileSystem(selectedFolder)">
          <mat-icon>delete</mat-icon>{{'modal.file.delete' | transloco}}
        </button>
      </div>
      <div class="properties-button-container">
        <button class="style-button"
            *ngIf="selectedFolder && !isRootSelected()"
            (click)="openPropertiesDialog('folder')"
            [disabled]="!isFileOwner(selectedFolder) || isFileSystem(selectedFolder)">
          <mat-icon>settings</mat-icon>
          Proprietà cartella
        </button>
      </div>
    </div>
    
    <!--Sezione select-->
    <!--<div class="select-section"
    *ngIf="selectedFolder && selectedFolder.folderName != '/' && selectedFolder.folderName != ' ' && selectedFolder.shareLevel">
      <div
        class="share-level-select">
        <label for="folderShareLevel">{{'modal.folder.shareLevel' | transloco}}</label>
        <select id="folderShareLevel" class="max-w-full" [(ngModel)]="selectedFolder.shareLevel"
          (change)="updateFolderShareLevel()"
          [disabled]="!isFolderOwner(selectedFolder)|| isFolderSystem(selectedFolder)">
          <option *ngFor="let option of shareLevelOptions" [value]="option.value">{{ option.text }}</option>
        </select>
        <label for="folderShareLevelEdit">{{'modal.folder.shareLevelEdit' | transloco}}</label>
        <select id="folderShareLevelEdit" class="max-w-full" [(ngModel)]="selectedFolder.shareLevelEdit"
          (change)="updateFolderShareLevelEdit()"
          [disabled]="!isFolderOwner(selectedFolder)|| isFolderSystem(selectedFolder)">
          <option *ngFor="let option of shareLevelEditOptions" [value]="option.value">{{ option.text }}</option>
        </select>

      </div>

    </div>-->
  </div>

  <!--  Seconda sezione del modal di caricametno file, sezione con elenco dei file contenuti nella cartella selezionata-------------------------------------------------->
  <div *ngIf="!isRootSelected()" class="files">
    <kendo-grid [kendoGridBinding]="files" [pageable]="true" [pageSize]="10" [sortable]="true"
      [sort]="[{'field': 'fileName', 'dir':'asc'}]" [resizable]="true" [selectable]="{'mode':'single'}"
      kendoGridSelectBy [(selectedKeys)]="selectedFiles" (selectionChange)="selectFile($event)" [height]="'100%'" [skip]="skip" 
      (pageChange)="onPageChange($event)">
      <kendo-grid-column field="fileName" title="" width="80" [filterable]="false" [sortable]="false">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span [ngClass]="{'external-file-icon': dataItem.isExternal}">
            <mat-icon>{{ getIcon(dataItem.fileName) }}</mat-icon>
          </span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="fileName" title="File" [filterable]="true" [sortable]="true">
      </kendo-grid-column>
      <kendo-grid-column field="size" [title]="'modal.file.size' | transloco" width="150" [filterable]="true"
        [sortable]="true">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span *ngIf="dataItem.isExternal" class="external-file-label">{{'modal.file.externalFile' | transloco}}</span>
          <span *ngIf="!dataItem.isExternal">{{ formatFileSize(dataItem.size) }}</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="lastModified" [title]="'modal.file.lastModified' | transloco" width="220"
        [filterable]="true" [sortable]="true">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ formatDate(dataItem.lastModified) }}
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>

  </div>

  <div *ngIf="isRootSelected()" class="no-selection-message">
    {{'modal.folder.select' | transloco}}
  </div>

  <!--  Terza sezione del modal di caricametno file, sezione anteprima del file selezionato --------------------------------------------------------------------------------->
  <div class="details" *ngIf="selectedFile">
    <div class="grid grid-cols-[80%_20%]">
      <!-- Nome del file -->
      <div class="font-extrabold truncate p-2" [title]="selectedFile.fileName">{{ selectedFile.fileName }}</div>

      <!-- header anteprima del file "bottone per richiedere l'anteprima"-->
      <div class="header-file-preview">
        <button class="open-preview style-button" (click)="openPreviewDialog(selectedFile)"
          [class.clickable]="isImageFile(selectedFile.fileName) || isPdfFile(selectedFile.fileName)">
          <mat-icon [svgIcon]="'heroicons_outline:arrows-pointing-out'"></mat-icon>
          <!-- <div>
          {{'modal.file.openPreviewButton' | transloco}}
        </div> -->
        </button>
      </div>


    </div>


    <!-- Corpo del file  "component base del modal per visualizzare l'antepriam"-->
    <div class="file-preview">
      <app-drake-file-preview [fileId]="selectedFile.id" [heightMode]="'FULL'"
        style="width: 100%; height: 100%;"></app-drake-file-preview>
    </div>



    <!-- Footer del file -->
    <div class="footer-file-preview">

      <!-- Footer bottoni -->
      <div class="actions">
        <button class="style-button" (click)="renameFile(selectedFile)"
          [disabled]="!isFileOwner(selectedFile) || isFileSystem(selectedFile)">
          <mat-icon>edit</mat-icon>{{'modal.file.rename' | transloco}}
        </button>

        <button class="style-button" (click)="deleteFile(selectedFile)"
          [disabled]="!isFileOwner(selectedFile) || isFileSystem(selectedFile)">
          <mat-icon>delete</mat-icon>{{'modal.file.delete' | transloco}}
        </button>
      </div>

      <div class="actions">
        <button [disabled]="selectedFile.isExternal" class="style-button" (click)="downloadFile(selectedFile)">
          <mat-icon>cloud_download</mat-icon>{{'modal.file.download' | transloco}}
        </button>
        <button class="style-button button-select" (click)="setFileValue(selectedFile)">
          <mat-icon>check_circle</mat-icon>{{'modal.file.select' | transloco}}
        </button>
      </div>

    </div>

    <div class="properties-button-container">
      <button class="style-button"
        *ngIf="selectedFile"
        (click)="openPropertiesDialog('file')"
        [disabled]="!isFileOwner(selectedFile) || isFileSystem(selectedFile)">
        <mat-icon>settings</mat-icon>
        Proprietà file
      </button>
      <!--<div
        *ngIf="selectedFolder && selectedFolder.folderName != '/' && selectedFolder.folderName != ' ' && selectedFolder.shareLevel"
        class="share-level-select">
        Lo share level della cartella non può essere modificato se la cartella è isSystem = true
        <label for="shareLevel">{{'modal.file.shareLevel' | transloco}}</label>

        <select id="shareLevel" class="max-w-full" [(ngModel)]="selectedFile.shareLevel"
          (change)="updateShareLevel(selectedFile)"
          [disabled]="!isFileOwner(selectedFile) || isFileSystem(selectedFile)">
          <option *ngFor="let option of shareLevelOptions" [value]="option.value">{{ option.text }}</option>
        </select>

        <label for="shareLevelEdit">{{'modal.file.shareLevelEdit' | transloco}}</label>

        <select id="shareLevelEdit" class="max-w-full" [(ngModel)]="selectedFile.shareLevelEdit"
          (change)="updateShareLevelEdit(selectedFile)"
          [disabled]="!isFileOwner(selectedFile) || isFileSystem(selectedFile)">
          <option *ngFor="let option of shareLevelEditOptions" [value]="option.value">{{ option.text }}</option>
        </select>
      </div>-->

    </div>
  </div>
</div>
